// Automatically generated
export const TIME_PICKER_COLUMN_STATE_KEYS = [
  "up",
  "down",
  "baseId",
  "unstable_idCountRef",
  "setBaseId",
  "unstable_virtual",
  "rtl",
  "orientation",
  "items",
  "groups",
  "currentId",
  "loop",
  "wrap",
  "shift",
  "unstable_moves",
  "unstable_hasActiveWidget",
  "unstable_includesBaseElement",
  "registerItem",
  "unregisterItem",
  "registerGroup",
  "unregisterGroup",
  "move",
  "next",
  "previous",
  "first",
  "last",
  "sort",
  "unstable_setVirtual",
  "setRTL",
  "setOrientation",
  "setCurrentId",
  "setLoop",
  "setWrap",
  "setShift",
  "reset",
  "unstable_setIncludesBaseElement",
  "unstable_setHasActiveWidget",
  "popover",
  "date",
  "selected",
  "setSelected",
  "visible",
  "columnType",
  "restoreOldTime",
  "updateOldTime",
] as const;
export const USE_TIME_PICKER_STATE_KEYS = [
  "baseId",
  "visible",
  "animated",
  "modal",
  "placement",
  "unstable_fixed",
  "unstable_flip",
  "unstable_offset",
  "gutter",
  "unstable_preventOverflow",
  "isDisabled",
  "isReadOnly",
  "pickerId",
  "dialogId",
  "segmentFocus",
  "value",
  "defaultValue",
  "onChange",
  "formatOptions",
  "placeholderDate",
  "autoFocus",
] as const;
export const TIME_PICKER_STATE_KEYS = [
  "fieldValue",
  "setFieldValue",
  "segments",
  "dateFormatter",
  "increment",
  "decrement",
  "incrementPage",
  "decrementPage",
  "setSegment",
  "confirmPlaceholder",
  "baseId",
  "unstable_idCountRef",
  "setBaseId",
  "unstable_virtual",
  "rtl",
  "orientation",
  "items",
  "groups",
  "currentId",
  "loop",
  "wrap",
  "shift",
  "unstable_moves",
  "unstable_hasActiveWidget",
  "unstable_includesBaseElement",
  "registerItem",
  "unregisterItem",
  "registerGroup",
  "unregisterGroup",
  "move",
  "next",
  "previous",
  "up",
  "down",
  "first",
  "last",
  "sort",
  "unstable_setVirtual",
  "setRTL",
  "setOrientation",
  "setCurrentId",
  "setLoop",
  "setWrap",
  "setShift",
  "reset",
  "unstable_setIncludesBaseElement",
  "unstable_setHasActiveWidget",
  "visible",
  "animated",
  "animating",
  "show",
  "hide",
  "toggle",
  "setVisible",
  "setAnimated",
  "stopAnimation",
  "modal",
  "unstable_disclosureRef",
  "setModal",
  "unstable_referenceRef",
  "unstable_popoverRef",
  "unstable_arrowRef",
  "unstable_popoverStyles",
  "unstable_arrowStyles",
  "unstable_originalPlacement",
  "unstable_update",
  "placement",
  "place",
  "pickerId",
  "dialogId",
  "isDisabled",
  "isReadOnly",
  "segmentFocus",
  "time",
  "hours",
  "minutes",
  "meridies",
  "hourState",
  "minuteState",
  "meridiesState",
] as const;
export const TIME_PICKER_KEYS = [
  ...TIME_PICKER_COLUMN_STATE_KEYS,
  ...TIME_PICKER_STATE_KEYS,
] as const;
export const TIME_PICKER_COLUMN_KEYS = TIME_PICKER_KEYS;
export const TIME_PICKER_COLUMN_VALUE_KEYS = [
  ...TIME_PICKER_COLUMN_KEYS,
  "value",
] as const;
export const TIME_PICKER_CONTENT_KEYS = TIME_PICKER_COLUMN_KEYS;
export const TIME_PICKER_SEGMENT_KEYS = TIME_PICKER_CONTENT_KEYS;
export const TIME_PICKER_SEGMENT_FIELD_KEYS = TIME_PICKER_SEGMENT_KEYS;
export const TIME_PICKER_TRIGGER_KEYS = TIME_PICKER_SEGMENT_FIELD_KEYS;
